'use strict';

function open($item) {
	var $content = $item.find('.sd-content'),
	    h = $content.children('.inner').outerHeight(true);

	$content.css({ 'max-height': h });
	$('body').icons.init('.svg-icon');
}

function close($item) {
	var $content = $item.find('.sd-content');
	$content.css({ 'maxheight': '0' });
	setTimeout(function () {
		$item.removeClass('open').find('.sd-content').removeAttr('style');
	}, 100);
}

function openCloseContent() {
	if ($('.js-slidedown').length > 0) {
		$('.sd-item > h5').on('click', function (e) {
			e.preventDefault();
			var $item = $(this).closest('.sd-item');
			if ($item.hasClass('open')) {
				close($item);
			} else {
				$item.siblings('li').each(function () {
					close($(this));
				});
				setTimeout(function () {
					open($item);
					$item.addClass('open');
				}, 100);
				// setTimeout(function () {
				// 	//if ( Modernizr.mq( '(max-width: 1023px)' ) ) {
				// 	$('html, body').animate({ scrollTop: $item.find('h5').offset().top - 80 }, 500);
				// 	//}
				// }, 600);
			}
		});
	}
};

var slideDown = {

	init: function init() {
		//console.log('test')
		openCloseContent();

		// If alreay open:
		// $('.sd-item').each(function () {
		// 	var $item = $(this);
		// 	if ($item.hasClass('open')) {
		// 		open($item);
		// 		// Fix:
		// 		if ($item.is(':not(.open)')) {
		// 			$('.sd-item.open').removeClass('open').find('.sd-content').removeAttr('style');
		// 		}

		// 	}

		// });
	}
};